<template>
  <v-app>
    <NavBar/>
    <v-main>
      <v-container>        
        <router-view />
      </v-container>
    </v-main> 
  </v-app>

</template>

<script>
import NavBar from '@/components/psychologist/NavBar.vue'

export default {
  name: 'PsychologistLayout',
  data() {
    return {      
    }
  },  
  components: {
    NavBar
  },
  computed: {
    hideMenu() {
      // Hide menu if route is /evaluation or starts with /evaluation/
      return this.$route.name === 'EvaluationView' || this.$route.path.startsWith('/evaluation');
    }
  }
}
</script>

<style>
.v-app {
  min-height: 100vh;
}
</style>